import {FormSection} from '@/components/commons/form-section/FormSection'
import {WarningBanner} from '@/components/commons/warning-banner/WarningBanner'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import dayjs, {formatLocaleDate} from '@/dayjs'
import {ProjectFormSourceField} from '@/features/projects/components/project-form/project-form-source-field/ProjectFormSourceField'
import {ProjectExtended} from '@/features/projects/types'
import {useTranslation} from '@/translations/i18n'
import {useOutletContext} from 'react-router-dom'
import {useTheme} from 'styled-components'

export const ProjectReopeningReferenceSection = ({isAllowed}: {isAllowed: boolean}) => {
    const {t} = useTranslation()
    const {project} = useOutletContext<{project: ProjectExtended}>()
    const {palette} = useTheme()

    const count = dayjs(project.expirationDate).diff(dayjs(project.endDate), 'day')

    return (
        <FormSection title={t('commons:reference_project')}>
            <Flexbox direction="column" gap={4} fullWidth>
                <ProjectFormSourceField />
                {!project.endDate || !project.expirationDate || !isAllowed ? (
                    <WarningBanner
                        title={t('projects:reopen_project_error_title')}
                        subtitle={t('projects:reopen_project_error_description')}
                    />
                ) : (
                    count > 0 && (
                        <Flexbox align="center" gap={1}>
                            <AlertCircleIcon size={14} color={palette.orange[500]} />
                            <Text palette="orange" shade="800" size="textSm">
                                {t('projects:project_closed_on', {
                                    date: formatLocaleDate(project.endDate, 'DD/MM/YYYY'),
                                    count
                                })}
                            </Text>
                        </Flexbox>
                    )
                )}
            </Flexbox>
        </FormSection>
    )
}
